<div (click)="handleClick()" (keyup.enter)="handleClick()" tabindex="0" class="feedback-sleeve" [class.is-active]="isActive">
  <div>
    <hls-icon icon="action-favorite-with-star"></hls-icon>
    <span [translate]="'carrier.feedback.give-feedback'"></span>
  </div>
</div>
